export const storeKeyFactory = {
  all: [{ scope: 'store' }] as const,
  stores: () => [{ ...storeKeyFactory.all[0], entity: 'stores' }] as const,
  myStore: () => [{ ...storeKeyFactory.all[0], entity: 'my-store' }] as const,
}
